function actionClosePopup(e){
 
  // close popup
  if (e.type == 'keypress') {
    if(e.which == 13 || e.which == 32) {
      $('body').removeClass('popup--open');
    }
  } else if (e.type == 'click') {
    $('body').removeClass('popup--open');
  }

  // store popup
  sessionStorage.setItem('displayPopup', 'false');
}


$(document).ready(function(){

  var displayPopup = sessionStorage.getItem('displayPopup');

  if (displayPopup !== 'false') {
   
    // init popup if exist
    if($('.popup__wrapper').length !== 0) {
      setTimeout(function(){
        $('body').addClass('popup--open');
      }, 2500);
    }
  
    // close popup
    $('.popup__close').on('click keypress', function(e){
      actionClosePopup(e);
    });
    
  }

});